<div class="card-container">
  <div class="icon-container">
    <div [ngClass]="icon"></div>
  </div>
  <div class="description" [ngClass]="font?.size">{{ description | translate }}</div>
</div>